const en = {
  home: 'Sky now',
  calculate: 'Calculate',
  charts: 'My charts',
  my_chart: 'My chart',
  calendario: 'Calendar',
  data: 'My data',
  buscador: 'Search',
  compatibility: 'Compatibility',
  rectification: 'Rectification',
  synastry: 'Synastry',
  composite_chart: 'Composite chart',
  select_chart: 'Select chart',
  myprofile: 'My profile',
  description: 'this is the sky now.',
  no_results: 'No results',
  hola: 'Hi',
  newest: 'Newest',
  agregar: 'Add',
  oldest: 'Oldest',
  favoritas: 'Starred',
  search_placeholder: 'Search by name or last name',
  editar: 'Edit',
  ver: 'See',
  compartir: 'Share',
  ShareFooter: 'Powered with Appstral precision',
  eliminar: 'Delete',
  no_cartas: 'No charts yet',
  no_favs: "You don't have any starred cards yet",
  no_favs_sub: 'Star your favorite characters to keep them handy',
  no_events: 'No events of these characteristics were found',
  minuto: 'Minute',
  hora: 'Hour',
  día: 'Day',
  semana: 'Week',
  mes: 'Month',
  año: 'Year',
  años: 'Years',
  planet_now: "{{planet}} at {{degree}}°{{minutes}}' {{retrograde}}  of  {{sign}}",
  planet_in_degree:
    "{{planet}} at {{degree}}°{{minutes}}' {{retrograde}}  of  {{sign}} in the {{house, ordinal}}",
  planet_range_one_sign:
    "{{planet}} from {{degreeStart}}°{{minutesStart}}' to {{degreeEnd}}°{{minutesEnd}}' in {{signStart}} {{retrograde}}",
  planet_range_two_signs:
    "{{planet}} from {{degreeStart}}°{{minutesStart}}' in {{signStart}} to {{degreeEnd}}°{{minutesEnd}}' in {{signEnd}} {{retrograde}}",
  ascendant_in_degree: "Ascendant at {{degree}}°{{minutes}}' of  {{sign}}",
  mc_in_degree: "Midheaven at {{degree}}°{{minutes}}'  of  {{sign}}",
  planets: {
    sol: 'Sun',
    luna: 'Moon',
    mercurio: 'Mercury',
    venus: 'Venus',
    marte: 'Mars',
    júpiter: 'Jupiter',
    saturno: 'Saturn',
    urano: 'Uranus',
    neptuno: 'Neptune',
    plutón: 'Pluto',
    lilith: 'Lilith',
    quirón: 'Chiron',
    nodo: 'North Node',
    'nodo norte': 'North Node',
  },
  signs: {
    aries: 'Aries',
    tauro: 'Taurus',
    géminis: 'Gemini',
    cáncer: 'Cancer',
    leo: 'Leo',
    virgo: 'Virgo',
    libra: 'Libra',
    escorpio: 'Scorpio',
    sagitario: 'Sagittarius',
    capricornio: 'Capricorn',
    acuario: 'Aquarius',
    piscis: 'Pisces',
  },
  Mayores: 'Majors',
  Menores: 'Minors',
  Aspects: {
    conjuncion: 'conjunction',
    semisextil: 'semi-sextile',
    sextil: 'sextile',
    cuadratura: 'square',
    trigono: 'trine',
    quincuncio: 'quincunx',
    oposicion: 'opposition',
  },
  invalid_year_range:
    'Invalid year range. Years must be between {{min}} and {{max}} and the start year must be before the end year.',
  search_error: 'An error occurred during the search.',
  connection_error: 'Could not connect to the server.',
  astrological_search: 'Astrological Search',
  planet_in_sign: 'Planet in Sign',
  planet: 'Planet',
  sign: 'Sign',
  degree: 'Degree',
  optional: '(optional)',
  motion: 'Motion',
  select: 'Select',
  retrogrado: 'Retrograde',
  directo: 'Direct',
  planetary_aspects: 'Planetary Aspects',
  aspect: 'Aspect',
  aspects: 'Aspects',
  natal_search_title: 'In chart',
  balance: 'Energy balance',
  natal_chart: 'Natal Chart',
  progressed_chart: 'Progressed Chart',
  natal_planet: 'Natal Planet',
  solar_revo: 'Solar Return',
  draconica: 'Draconic Chart',
  progressions: 'Secondary Progressions',
  transits: 'Transits',
  transit: 'Transit',
  solar: 'Solar',
  time_range: 'Time Range',
  start_year: 'Start Year',
  end_year: 'End Year',
  search: 'Search',
  loading: 'Searching',
  calculating: 'Calculating',
  results: 'Results',
  no_more_results: 'No more results',
  search_results_count: 'Your search returned {{count}} results',
  loadingData: 'Loading data',
  noUserDataFound: 'No user data found.',
  personalData: 'Personal Data',
  name: 'Name',
  birthDate: 'Birth Date',
  birthTime: 'Birth Time',
  birthCity: 'Birth City',
  changePassword: 'Change password',
  passwordChangedSuccessfullyAndLoggedOut: "Password changed successfully. You've been logged out.",
  noUserLoggedInOrEmailMissing: 'No user logged in or email is missing.',
  requiresRecentLoginPrompt: 'Please re-enter your current password to confirm your identity.',
  incorrectCurrentPassword: 'Incorrect password entered',
  passwordChangeError: 'Failed to change password',
  newPassword: 'New Password',
  currentPassword: 'Current password',
  confirmNewPassword: 'Confirm New Password',
  passwordsDoNotMatch: 'Passwords do not match.',
  passwordTooShort: 'Password must be at least 6 characters long.',
  passwordChangedSuccessfully: 'Password changed successfully.',
  changePasswordButton: 'Change',
  languageSelection: 'Language',
  toggleLanguage: 'Toggle Language',
  english: 'English',
  spanish: 'Spanish',
  membership: 'Membership',
  membershipType: 'Membership Type',
  changeHouseSystem: 'House System',
  selectHouseSystem: 'Select house system',
  selectAnOption: 'Select an option',
  pleaseSelectHouseSystem: 'Please select a house system.',
  houseSystemChangedSuccessfully: 'House system changed successfully.',
  houseSystemChangeError: 'Error changing house system',
  changeHouseSystemButton: 'House System',
  legal: 'Legal',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms and Conditions',
  profile: {
    Placidus: 'Placidus',
    Topocentric: 'Topocentric',
    Koch: 'Koch',
    EqualHouses: 'Equal Houses',
    WholeSigns: 'Whole Signs',
    membershipType: 'Membership Type',
    cancelMembership: 'Cancel My Membership',
  },
  stellarMember: 'STELLAR MEMBER',
  notAvailable: 'Not available',
  notYetAMember: 'Not a member yet!',
  stellarDescription:
    'You have access to all Appstral Web features and can calculate unlimited charts.',
  stellarPrice: 'Your subscription price is $1 USD per month',
  solarMember: 'SOLAR MEMBER',
  solarDescription: 'You have access to the solar returns for your and all your other charts.',
  solarPrice: 'Your subscription price is $1 USD per month',
  logout: 'Log out',
  deleteAccount: 'Delete Account',
  Subscribe: 'Subscribe',
  form: {
    nombre: 'Name',
    apellido: 'Lastname',
    fecha_nacimiento: 'Birth date',
    hora_nacimiento: 'Birth time',
    select_country: 'Select a country',
    select_city: 'Select a city',
    select_city_search: 'Search a city',
    fecha_error_rango: 'Invalid date. Check day, month and year (1700–2100).',
    hora_error: 'Invalid time (00:00 to 23:59).',
    nombre_error: 'Name can only contain letters, spaces, hyphens and apostrophes.',
    apellido_error: 'Lastname can only contain letters, spaces, hyphens and apostrophes.',
  },

  rectificacion: {
    titulo: 'Rectification',
    subtitulo: 'Find the most likely birth time from real life events.',
    hora_estimada: 'Estimated time',
    rango_busqueda: 'Search range',
    eventos: 'Life events',
    evento_descripcion: 'Event description',
    evento_categoria: 'Event category',
    categoria_grupos: {
      vida_muerte: 'Life / Death',
      familia: 'Family / Bonds',
      trabajo: 'Work / Career',
      salud: 'Health',
      residencia: 'Residence',
      educacion: 'Education',
      logros: 'Achievements',
      legal: 'Legal / Judicial',
      crisis: 'Crisis / Transformation',
      otros: 'Other',
    },
    categorias: {
      muerte_padre: 'Death of father',
      muerte_madre: 'Death of mother',
      muerte_hermano: 'Death of sibling',
      muerte_conyuge: 'Death of spouse / partner',
      muerte_hijo: 'Death of child',
      muerte_otro: 'Death (other relation)',
      accidente_grave: 'Serious accident',
      matrimonio: 'Marriage',
      separacion: 'Separation / divorce',
      relacion: 'Relationship',
      hijo: 'Birth of child',
      adopcion: 'Adoption',
      hermano: 'Birth of sibling',
      ruptura_familiar: 'Family rift',
      trabajo: 'New job',
      ascenso: 'Promotion',
      despido: 'Layoff / firing',
      negocio: 'Own business',
      quiebra: 'Bankruptcy',
      cambio_carrera: 'Career change',
      jubilacion: 'Retirement',
      diagnostico: 'Diagnosis',
      operacion: 'Surgery',
      accidente: 'Accident',
      recuperacion: 'Recovery',
      tratamiento: 'Treatment',
      mudanza: 'Move',
      emigracion: 'Emigration',
      compra_casa: 'Home purchase',
      perdida_hogar: 'Loss of home',
      estudio: 'Start of studies',
      graduacion: 'Graduation',
      abandono_estudio: 'Dropping out',
      logro_publico: 'Public achievement',
      fama: 'Fame',
      fracaso_publico: 'Public failure',
      juicio_inicio: 'Lawsuit filed',
      juicio_sentencia: 'Court ruling',
      juicio_ganado: 'Lawsuit won',
      juicio_perdido: 'Lawsuit lost',
      condena: 'Conviction',
      libertad: 'Release / freedom',
      herencia_legal: 'Inheritance',
      deuda_legal: 'Legal debt',
      trauma: 'Trauma',
      fractura: 'Fracture',
      crisis: 'Crisis',
      viaje: 'Travel',
      conversion: 'Conversion / faith',
      terapia: 'Therapy',
      otro: 'Other',
    },
    agregar_evento: 'Add event',
    eventos_minimos: 'Add at least 3 sharp, well-dated events.',
    rectificar: 'Rectify',
    calculando: 'Computing',
    volver: 'Back to form',
    error: 'Something went wrong. Check the data and try again.',
    hora_seleccionada: 'Selected time',
    score: 'Score',
    hits_angulares: 'Angular hits',
    historial: 'Recent rectifications',
    historial_vacio: 'Your recent rectifications will show up here.',
    reset: 'Clear form',
    robustez: 'Robustness',
    robusto: 'Sharp result',
    ambiguo: 'Ambiguous result',
    vs_segunda: 'vs. {{hora}} (Δscore {{diff}})',
    carta_natal: 'Natal chart',
    col_grafico: 'Score by time',
    leyenda_mejor: 'best time',
    leyenda_seleccionada: 'selected time',
    leyenda_score: 'score per minute',
    eje_x: 'candidate birth time',
    col_direcciones: 'Directions',
    col_speculum: 'Speculum',
    tocan_angulo: '{{n}}/{{total}} hit an angle ≤{{dias}} days',
    evento: 'Event',
    direccion: 'Direction',
    delta_dias: 'Δdays',
    angulo: 'Angular',
    sin_direccion: 'no direction within window',
    punto: 'Point',
    info: {
      abrir: 'How rectification works',
      titulo: 'How Rectification Works',
      cerrar: 'Close',
      intro:
        'Rectification estimates the most likely birth time by testing every candidate time within the selected range and scoring how well each one explains the life events you provided.',
      secciones: [
        {
          h: 'Method',
          p: [
            'Appstral uses Primary Directions with the Naibod time key — one of the oldest and most precise predictive techniques in astrology, based on the actual diurnal rotation of the sky rather than planetary movement.',
            'For each candidate birth time, the engine calculates directions between all planets and the chart angles (Ascendant and Midheaven) for all five major aspects, in both Direct and Converse motion, using zodiacal directions with latitude.',
          ],
        },
        {
          h: 'Scoring',
          p: [
            'Each event is matched with its closest direction. The score reflects how far that direction falls from the actual event date — lower is better.',
            'Directions to the Ascendant or Midheaven carry more weight, because these are the only points that shift significantly with small changes in birth time. Directions involving Saturn, Uranus, Neptune or Pluto also carry additional weight, given their historical role in marking major life transitions.',
          ],
        },
        {
          h: 'Angular Hits',
          p: [
            'The count shown below the Directions table (e.g. 3/5 angular hits ≤30 days) measures how many events are reproduced by a direction to the Ascendant or Midheaven within thirty days of the recorded date. This is the most reliable signal of a strong rectification — angular directions are uniquely sensitive to the exact birth time.',
          ],
        },
        {
          h: 'Robustness',
          p: [
            'Robustness measures how clearly the best candidate separates from the next one. A clear result means the best birth time scores significantly better than any alternative. An ambiguous result means two or more candidate times perform similarly — which usually calls for additional life events or astrological judgment to resolve.',
          ],
        },
        {
          h: 'Interpreting Results',
          p: [
            'A strong result typically combines a low overall score, several angular hits within a short time window, and clear separation from nearby candidates. The Speculum table shows the exact astronomical coordinates used in the calculations.',
            'Rectification is a probability estimate, not a certainty. The quality of the result depends directly on how precise and biographically significant the selected events are.',
          ],
        },
      ],
    },
  },
  movimiento: 'Motion',
  retrograde: 'Retrograde',
  direct: 'Direct',
  searchby: 'Search by',
  posicion: 'Position',
  nueva_carpeta: 'New folder',
  nombre_nueva_carpeta: 'Create folder',
  editar_nombre_carpeta: 'Edit folder',
  mover_a: 'Move to',
  quitar_de_carpeta: 'Remove',
  carpeta_vacia_titulo: 'There are no stars here yet',
  carpeta_vacia_sub: 'Create or move a chart to this folder.',
  volver_mis_cartas: 'Go back to My charts',
  alert: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirm_delete_title: 'Are you sure?',
    confirm_delete_message: "Are you sure you want to delete {{nombre}} {{apellido}}'s chart?",
    confirm_delete_folder: 'Are you sure you want to delete the folder "{{nombre}}"?',
  },

  Policy: {
    title: 'Data Protection Policy',
    introduction:
      "This Privacy Policy describes how APPSTRAL (hereinafter, 'APPSTRAL' or 'Platform') collects, stores, and uses the personal information of users who access the Platform. By using the Platform, you accept the terms established in this Privacy Policy and authorize the collection and use of your personal data as detailed herein. APPSTRAL asks you to read this Privacy Policy carefully.",
    subtitle1: 'Introduction',
    description1:
      'The term “Personal Data” refers to any information that can identify you, such as your name, email address, telephone number, postal address, or other contact information. APPSTRAL guarantees that it will process your Personal Data in accordance with this Privacy Policy and in compliance with Law 25.326 on the Protection of Personal Data. However, in specific cases, we may process it to comply with legal, regulatory, or other obligations. judicial.',
    subtitle2: 'Who is the Controller of your data?',
    description2:
      'The controller of your personal data is:\n● Identity: SITTA TOMÁS RODRIGO\n● DNI: 42.876.938\n● CUIT 20-42876938-5\n● Tax address: Molière 683, Floor 1, Apt. 1, Autonomous City of Buenos Aires\n● Email: contacto@appstral-soporte.com',
    subtitle3: 'What information is collected and from where?',
    description3:
      'By submitting their personal data via email or by filling out any form on the Platform, the User consents to APPSTRAL processing it in accordance with this data protection policy.\nBy using the services offered by APPSTRAL, Data such as: date, time, and place of birth, among others, as well as bank details for the collection of the premium subscription if requested, in accordance with our Terms and Conditions of Use. No sensitive or personal contact data is collected, except for that strictly necessary for the operation of the app.',
    subtitle4: 'Data retention period?',
    description4:
      'The data provided by the user will be kept for the duration of the business relationship with our company, without prejudice to the interested party being able to request its deletion.',
    subtitle5: 'Purpose and legality of data processing',
    description5:
      "The personal data collected by APPSTRAL is intended to:\n1. Facilitate, expedite, and comply with the correct provision of the astrological chart analysis and generation services offered through the platform.\n2. Manage requests, queries, and complaints made by the User.\n3. Inform the User about news, updates, promotions, and proposals related to APPSTRAL services, through automated or non-automated means (email, SMS, in-app notifications, among others), which we consider may be of interest to the User.\n4. Personalize the User's experience, including the creation of astrological profiles based on the information provided, in order to offer interpretations and content more appropriate to their interests and needs.\nThe User acknowledges and accepts that failure to provide certain personal data may prevent APPSTRAL from adequately providing the services linked to said data.",
    subtitle6: 'User Withdrawal.',
    description6:
      'The user has the right to withdraw their consent at any time, and must communicate this through the following contact methods: contact@appstral-soporte.com. As a general rule, the withdrawal of consent will not affect the use of the Platform. On those occasions in which the User must provide their data through the established fields to make inquiries, request information, or for reasons related to the content of the Platform, they will be duly informed if the completion of any of them is mandatory. This will occur when this data is essential for the correct development of the operation.',
    subtitle7: 'Data Recipients',
    description7:
      'The personal data provided by the User will not be communicated to third parties, unless necessary for the provision of the requested services, of which the User will be promptly informed, or when the User has expressly agreed to its communication. Personal data may be communicated to the competent Public Administrations and Bodies, in accordance with current legislation and in accordance with the corresponding legal obligations.',
    subtitle8: 'Security of Personal Data',
    description8:
      'APPSTRAL undertakes to adopt the necessary technical and organizational measures, according to the level of security appropriate to the risk of the data collected, in order to guarantee the security of personal data and prevent the accidental or unlawful destruction, loss, or alteration of personal data transmitted, stored, or otherwise processed, or the unauthorized communication or access to such data. However, because APPSTRAL cannot guarantee the total security of the Internet, nor the total absence of hackers, who fraudulently access personal data, the data controller undertakes to inform the User, without undue delay, that a breach of personal data security has occurred, and that it is likely to entail a high risk to the rights and freedoms of natural persons.',
    subtitle9: 'Minors',
    description9:
      "Access, use, and subscription to the Platform are permitted only for persons of legal age and with full legal capacity to enter into contracts, in accordance with the legislation in force at the Visitor's and/or User's domicile. Access, use, subscription, or browsing by minors is expressly prohibited. Any breach of this provision will constitute a violation of these Privacy Policies. Parents, guardians, or legal representatives will be responsible for any unauthorized use of APPSTRAL by minors, as well as for any damages that such use may cause to both the minor and third parties.\nAccess, use, and subscription to the Platform are permitted only for persons of legal age and with full legal capacity to enter into contracts, in accordance with the legislation in force at the Visitor's and/or User's domicile. Access, use, subscription, or browsing by minors is expressly prohibited. Any breach of this provision will constitute a violation of these Privacy Policies. Parents, guardians, or legal representatives will be responsible for any unauthorized use of APPSTRAL by minors, as well as for any damages that such use may cause to the minor or to third parties. Access, use, and subscription to the Platform are permitted only for persons of legal age and with full legal capacity to enter into contracts, in accordance with the legislation in force at the Visitor's and/or User's domicile. Access, use, subscription, or browsing by minors is expressly prohibited. Any breach of this provision will constitute a violation of these Privacy Policies. Parents, guardians, or legal representatives will be responsible for any unauthorized use of APPSTRAL by minors, as well as for any damages that such use may cause to the minor or to third parties.",
    subtitle10: 'User Rights',
    description10:
      'Visitors and/or Users have the right to access, rectify, update, block or delete the Personal Data they have provided to APPSTRAL, either directly or through a third party. These rights may only be exercised on information that is considered personal data as established in Law No. 25,326 on the Protection of Personal Data.\nTo exercise any of these rights, the Visitor must send an email to contacto@appstral-soporte.com, indicating their first and last name, ID number, the details of their request and the reasons for exercising their right.\nOnce the request is received, APPSTRAL will evaluate its origin and notify the User whether their request has been accepted or rejected. In the case of a request for access to data, the response period will be 10 business days from receipt of the request. If it is a request for rectification, update or deletion, the response will be provided within 5 business days.\nIn accordance with the Pursuant to DNPDP Provision No. 10/08, the owner of personal data has the right to access their personal data free of charge every six months, unless they can prove a legitimate interest in accordance with Article 14, paragraph 3 of Law No. 25,326. The Agency for Access to Public Information, in its capacity as the Control Body of Law No. 25,326, is the entity responsible for receiving complaints and claims related to non-compliance with personal data protection regulations in Argentina.',
    subtitle11: 'Links to third-party sites',
    description11:
      'The Platform may contain links to third-party websites. APPSTRAL is not responsible for the privacy policies or content of such sites. It is recommended that you read the privacy policies of each page you visit.',
    subtitle12: 'Modification of the Privacy Policy',
    description12:
      'APPSTRAL reserves the right to modify its confidentiality and data protection policy as a result of legislative changes or modifications to its computer data processing policy. If any changes occur, the information will be published on this page, where you can access the current confidentiality and data protection policy. In each case, the relationship with users will be governed by the rules in force at the time the Platform is accessed.',
  },

  Terms: {
    title: 'Terms and Conditions of Use',
    subtitle1: '1. IDENTIFICATION DATA OF THE SERVICE PROVIDER',
    description1:
      'This application, named APPSTRAL (hereinafter referred to as APPSTRAL or the “Platform”), is developed and operated by SITTA TOMÁS RODRIGO, National ID No. 42.876.938, CUIT No. 20-42876938-5, with registered address at Molière 683, 1st Floor, Apartment 1, Autonomous City of Buenos Aires, Postal Code 1407, Argentine Republic.',
    subtitle2: '2. TERMS AND CONDITIONS OF USE',
    description2:
      '2.1 These general conditions apply to all commercial relations between the User and APPSTRAL, unless expressly agreed otherwise in writing.\n2.2 Access to this Platform is the sole responsibility of the Users and implies acceptance of these terms and conditions of use. By accepting them, it is understood that the User has fully agreed to the contract and has therefore read and understood each and every one of the terms, committing to comply with all specifications established therein.\n2.3 The User must make lawful use of this Website and its services in accordance with these terms and conditions of use and current legislation.\n2.4 Likewise, APPSTRAL may unilaterally modify the terms and conditions of use of this Website by publishing them in this legal notice, which will take effect from the moment of publication.\n2.5 All trademarks, trade names or distinctive signs of any kind that appear on the Website are the property of APPSTRAL or, where applicable, of third parties who have authorized their use. The use or access to the Portal and/or the Contents shall not be understood as granting the User any rights over such trademarks, trade names and/or distinctive signs, nor any exploitation rights that may exist or arise over said contents.',
    subtitle3: '3. SERVICES PROVIDED BY APPSTRAL',
    description3:
      "3.1 The purpose of this contract is the provision of a service through a digital tool intended for astrological analysis.\n3.2 APPSTRAL is a digital tool specialized in astrological analysis, designed to offer users a complete and accurate experience in exploring their natal chart and other astral phenomena. Through the application, users can access various features, including:\n3.2.1 Natal chart visualization: Detailed generation of the natal chart based on the user's date, time, and place of birth.\n3.2.2 Solar return calculation: Personalized analysis of the so-called 'astrological birthday', allowing users to anticipate trends and predominant energies for the year.\n3.2.3 Real-time astronomical sky visualization: Interactive representation of the current position of celestial bodies, providing a direct astronomical observation experience from the app.\n3.2.4 Planetary positions and ephemeris consultation: Access to precise data on the location of planets and other celestial bodies at different times.\n3.2.5 Tracking lunar phases and astral events: Updated information on the phases of the Moon and other relevant phenomena, such as eclipses or planetary retrogrades.\n3.3 To ensure maximum accuracy in astrological calculations, APPSTRAL uses the official Swiss Ephemeris license provided by www.astro.com, in accordance with its respective terms of use.\n3.4 The User agrees to use the platform responsibly, releasing APPSTRAL from any liability arising from improper, erroneous, or illegal use of the website or application.",
    subtitle4: 'ENTRY INTO FORCE OF THE GENERAL TERMS AND CONDITIONS',
    description4:
      'The General Terms and Conditions shall enter into force and be applicable to APPSTRAL and the User from the moment the User makes use of the application, as such use implies full and unconditional acceptance of these Terms and Conditions. If you do not agree with them, you are requested to refrain from using the application.',
    subtitle5: 'PRIVACY POLICY',
    description5:
      '5.1 The privacy policy contained in these General Terms and Conditions must be accepted jointly with them. The information you provide to APPSTRAL is absolutely necessary and is intended to enable us to provide you with the services available through the platform.\n5.2 The required data will be processed in accordance with Argentine Law No. 25.326 on the Protection of Personal Data (Habeas Data).\n5.3 Likewise, your personal data will not be sold or transferred to third parties without your express consent.',
    subtitle6: '6. INFORMATION AND REQUESTED DOCUMENTATION',
    description6:
      "6.1 Both individuals and legal entities who access the Platform, register on it, and provide the requested information during the registration process may use 'APPSTRAL' and, therefore, the services made available to the User. This information is collected in order to enable a service with more features for the end user.\n6.2 Additionally, for more information about our data protection and privacy policy, please refer to our Privacy Policy.",
    subtitle7: '7. MINORS',
    description7:
      'Minors are not allowed to use the services provided by APPSTRAL through the Website. Therefore, any request to register as a member of APPSTRAL by a person under eighteen (18) years of age will be denied.',
    subtitle8: '8. SERVICE MODALITIES',
    description8:
      "8.1 APPSTRAL offers three service modalities:\n8.1.1 Free Plan, which includes:\n● Up to 5 astrological charts saved in the collection.\n● Solar return of the user's own chart.\n● Planetary transits on the user's own chart.\n● Access to Stella with a limit of 5 daily queries.\n● Access to general ephemeris.\n8.1.2 Solar Member Plan (USD 0.99/month), which includes everything in the free plan, plus:\n● Solar return of any chart in the collection.\n● Planetary transits on any chart in the collection.\n8.1.3 Stellar Member Plan (USD 1.99/month), which includes everything in the Solar Member plan, plus:\n● Unlimited astrological charts.\n● Unlimited access to Stella.\n● Personalized transit notifications.\n● Personalized ephemeris with astrological interpretation generated by artificial intelligence.\n● Secondary progressions (available in the web version).\n● Draconic charts (available in the web version).\n8.2 The platform has a subscription system that enables exclusive features for premium users. Subscriptions are managed through the app stores from which APPSTRAL is distributed: Apple's App Store on iOS devices and Google Play on Android devices.\n8.3 Payment for the subscriptions, the costs of which are detailed in section 8.1, is made exclusively through the store from which the User downloaded the application — the App Store on iOS or Google Play on Android — with Apple or Google, as applicable, being responsible for commercial intermediation and payment processing. The application owner has no access to or control over payment data, the billing process, or accreditation deadlines. Managing, renewing, and cancelling the subscription is done from the User account in the corresponding store.\n8.4 Regarding the subscription to the premium service, it will be activated once correct registration and payment have been verified. This may take up to 48 hours for reasons beyond the control of the app owner. Under no circumstances may compensation, reimbursement, or indemnity be required for such delay.\n8.5 APPSTRAL Users can find more information regarding the services offered, as well as the price and fees for using them, by accessing the 'Membership' section of the Platform.",
    subtitle9: '9. OBLIGATIONS',
    description9:
      "9.1 APPSTRAL undertakes to:\n9.1.1 Respond as diligently as possible to all queries that the User may have arising from the use of the services offered.\n9.1.2 Provide the service to the Client in accordance with the provisions of these conditions.\n9.1.3 Keep the APPSTRAL platform operational 24 hours a day, except for temporary interruptions due to website maintenance services, technical or computer problems such as internet outages caused by any cause, computer attacks and similar situations that temporarily make the provision of the service impossible. This will be restored as soon as the incidents have been resolved.\n9.1.4 Notify any movement that APPSTRAL may consider suspicious in order to compromise the security of the User's account, for subsequent analysis.\n9.2 The User undertakes to:\n9.2.1 Communicate to APPSTRAL all the data necessary for access and use of services that require prior identification, which must be truthful, current and accurate.\n9.2.2 Confirm acceptance of these General Conditions by checking the box in the application inviting you to accept the terms and conditions of APPSTRAL.\n9.2.3 Make appropriate use of the Services included in the APPSTRAL Platform, always in accordance with the legal system.\n9.2.4 Not to carry out any activity that hinders or interferes with the operation of the Services included in the Platform.",
    subtitle10: '10. EXCLUSIONS OF LIABILITY',
    description10:
      "10.1 The services offered through the APPSTRAL platform comply with the provisions of Argentine law. APPSTRAL shall not be liable for those services that do not comply with the legal provisions of other countries that may be accessed by users outside of Argentina.\n10.2 The Platform is exonerated from any liability in the following cases: 10.2.1 Improper use of the APPSTRAL platform by the User. 10.2.2 Damages or losses suffered as a result of unforeseeable or unavoidable events, including, but not limited to, acts of God or force majeure. 10.2.3 Failures, technical errors, accidents, breakdowns, manipulations, service interruptions, or other incidents that may occur in equipment or technical services other than “APPSTRAL,” whose correct operation is necessary for the provision of the service. 10.2.4 Temporary unavailability of the platform due to force majeure or technical suspensions necessary for the maintenance or improvement of the service. 10.3 The User shall be liable for any damages that may be caused to third parties due to the improper use of the data provided, including, but not limited to: 10.3.1 The use of inaccurate, false, or untrue data. 10.3.2 The use by third parties of the User's personal access credentials.",
    subtitle11: '11. APPSTRAL ASSIGNMENT AND SUBROGATION',
    description11:
      'APPSTRAL, if it deems it necessary, may assign or subcontract the contracts entered into with Users to other entities to carry out the purpose of the contract as established in these General Conditions.',
    subtitle12: '12. SUPPORT AND COMPLAINTS',
    description12:
      '12.1 For any questions, technical issues, complaints, or support requests, the User may contact us via email at:\ncontact@appstral-soporte.com.\n12.2 We will endeavor to provide a response within a reasonable timeframe, always prioritizing effective and timely assistance.',
    subtitle13: '13. NOTIFICACIONES Y ACTUALIZACIONES',
    description13:
      'El Usuario podrá optar por recibir o no notificaciones dentro de la aplicación relacionadas con novedades, actualizaciones, alertas y mejoras. Esta preferencia podrá configurarse directamente en el perfil de usuario.',
    subtitle14: '14. INTELLECTUAL PROPERTY AND TRADEMARK',
    description14:
      'The APPSTRAL trademark is registered in the name of SITTA TOMÁS RODRIGO and is protected by current industrial property legislation. All content, designs, interfaces, source code, functionalities, texts, images, databases, and other elements comprising APPSTRAL are the exclusive property of its owner and may not be reproduced, distributed, or used without its express written authorization.',
    subtitle15: '15. CONSUMER PROTECTION',
    description15:
      "APPSTRAL respects the rights of users as consumers, in accordance with Law No. 24,240 and other applicable regulations. In the event of any inconvenience, the User may resort to both the platform's own customer service channels and official consumer protection agencies.",
    subtitle16: '16. APPLICABLE LAW AND JURISDICTION',
    description16:
      'These Terms and Conditions are governed by the current legislation of the Argentine Republic. For any dispute arising from the use of the application, the parties submit to the jurisdiction of the ordinary courts of the Autonomous City of Buenos Aires, waiving any other jurisdiction that may apply.',
  },
  button_label: {
    edit: 'Edit',
    delete: 'Delete',
    star: 'Star',
    share: 'Share',
    details: 'Details',
    fast: 'Fast Planets',
    rectificar: 'Rectify',
  },
  elemento: 'Elements',
  ritmo: 'Rhythms',
  polaridad: 'Polarities',
  error: {
    ups: 'Oops!',
    mal: 'Something went wrong',
    texto: 'Please try again. If the problem persists, please contact Appstral Support.',
    boton: 'Go home',
  },
  orbes: 'Orbs',
  luminarias: 'Luminaries',
  internos: 'Personals',
  externos: 'Transpersonals',
  otros: 'Others',
  angulos: 'Angles',
  orbInfo:
    'Appstral allows you to choose the orb degrees for each planetary aspect simply and quickly, arranging them into five categories: Luminaries (Sun and Moon), Personals (Mercury to Saturn), Transpersonals (Uranus, Neptune, Pluto), Others (Chiron, Lilith, and North Node), and Angles (for aspects to cusps such as the Ascendant and Midheaven).',
  suscribeModal: {
    logoAlt: 'Appstral Logo',
    title: 'Start your subscription process by downloading the app on your mobile:',
    appleQrAlt: 'QR code for Apple App Store',
    androidQrAlt: 'QR code for Google Play Store',
    descriptionPart1: 'Become an',
    memberHighlight: 'Stellar Member',
    descriptionPart2: 'and gain access to the most precise astronomical software on the planet.',
  },
  subscriptionModal: {
    title: "It seems you're not a member yet!",
    message:
      'Subscribe for only $1 USD from the Appstral mobile and get access to all the features for astral charts.',
    closeBtn: 'Close',
    androidQrAlt: 'QR code for Android',
    appleQrAlt: 'QR code for iOS',
    ExtraChartsTitle: 'It seems you have no more charts available!',
    ExtraChartsSubtitle:
      'Subscribe for just $1 USD from the Appstral mobile app and create unlimited astral charts.',
    SubscribeTitle: 'Discover the cosmos without limits!',
    SubscribeSubtitle:
      'Subscribe for only $1 USD from Appstral mobile and access all our features.',
  },
  notPremiumModal: {
    welcomeTitle: 'Welcome!',
    message:
      'Your login was successful, but your account is not premium. Upgrade your plan to access more features!',
    closeButton: 'Close',
  },
  loginPage: {
    forgotPassword: 'Forgot your password?',
    appstralStarAlt: 'Appstral Star Logo',
    appstralLogoAlt: 'Appstral Web Logo',
    slogan: 'The sky in your hands',
    loginTitle: 'Sign in to your account',
    emailPlaceholder: 'Email address',
    passwordPlaceholder: 'Password',
    notMemberPart1: 'If you are not a member,',
    subscribeHere: 'register here',
    loginButtonText: 'Login',
    footerCopyright: '© Appstral 2026. All rights reserved.',
    invalidCredentialsError: 'Invalid credentials. Please try again.',
    loginError: 'Login error. Please try again later.',
    premiumLoginSuccess: 'Login successful! You are a premium member.',
    aboutLink: 'About Appstral',
  },
  registerModal: {
    title: 'Create account',
    subtitle: 'Fill in your birth details to get started.',
    noTime: 'No time',
    passwordHint: 'Password must be at least 6 characters.',
    submit: 'Sign up',
    cancel: 'Cancel',
    loading: 'Creating account',
    emailInUse: 'That email is already registered.',
    invalidEmail: 'The email format is invalid.',
    weakPassword: 'Password must be at least 6 characters.',
    genericError: 'An unexpected error occurred. Please try again.',
  },
  aboutModal: {
    title: 'About Appstral',
    intro:
      'Nothing truly new is created by trying to create something new. New things emerge when people respond to what the present moment is asking for.',
    sections: [
      {
        heading: 'How it started',
        paragraphs: [
          'Everything that came before Appstral made Appstral possible: the Babylonian cuneiform tablets, astrolabes, medieval ephemerides copied by hand for centuries, the first astrological computers of the 1970s, every open-source library. These are the tools that came before us, and we try to honor them with admiration and respect.',
          'We believe in bringing a human vision to technology. Astrology has always occupied a strange third position between science and spirituality. Today, somewhere between the human and the machine, we believe it may be able to find that place again: technology not as a replacement for human experience, but as a tool in service of it.',
          "There was a difficult year before all of this began. And during that year an uncomfortable truth appeared: it's possible to know a great deal about astrology, even teach it, while no longer truly paying attention to the sky. No longer living within the rhythms astrology invites us to notice.",
          "Because astrology is, above all, a language. And like any language, it's learned through practice. Not only through a course once a year, but through small everyday consultations: checking where the Moon is today, understanding the transit you're going through during a difficult week, remembering that a square may last a few days — not an entire lifetime.",
          'Appstral was born from that need. The need for a tool that could be close at hand every day, something more like a weather app or a calendar than professional software: not a place to spend hours inside of, but something you can check quickly and return to life feeling a little more oriented than before.',
          'In January 2025, in Buenos Aires, we wrote the first lines of code to calculate a natal chart. It worked, and that was the beginning.',
        ],
      },
      {
        heading: 'What we want it to be',
        paragraphs: [
          'An application deep enough for professional astrologers: client galleries, transits, progressions, solar returns, ephemeris search, all built with rigor.',
          "And at the same time, a place where someone who's just beginning — someone who simply wants to know where their Moon is — can find something welcoming and clear, without having to learn house systems and orb settings before seeing their first chart.",
          'Both audiences in the same place, powered by the same engine and built with the same care in every detail.',
        ],
      },
      {
        heading: 'Stella',
        paragraphs: [
          "Stella is Appstral's conversational astrologer: a tool for curiosity and exploration.",
          'For the newcomer, curiosity. Being able to ask what the Midheaven is, or what it means to have it in a certain sign, without needing any prior astrological knowledge.',
          "For the professional, reach. Asking Stella to list every past solar return in which your Ascendant fell into a specific sign. Finding the exact dates when a client's progressed Moon changed signs. Searching in seconds for things that once required an entire afternoon with open ephemerides.",
          "Stella has real access to ephemeris calculations and chart context. If you ask where Uranus was on a specific day in 1917, it calculates it. If you ask what transits you're experiencing today, it reads your chart and responds from there — not with generic answers.",
          'We think of Stella as a bridge: a way for technical astrological language to become more accessible without losing depth.',
          'The meeting of two souls in an astrology consultation — that moment when someone looks you in the eyes while sharing their life with an open heart and an open chart — is unique, and impossible to replicate.',
          'Stella is not here to replace that experience, but to reach the moments when that encounter is not possible. It is a way of extending the reach of our project, bringing it to places and moments where we ourselves could never physically be.',
        ],
      },
      {
        heading: 'Who we are',
        paragraphs: [
          'There are four of us, and we met while studying astrology. Some of us read charts and give consultations, some focused on visual design, and some wrote the code. We are friends, and we came together because we felt this could be done differently.',
          'The interpretations, glossary, and every astrological text inside the application were written by us. The visual design too. The code too. Everything inside Appstral has passed through our hands, our decisions, and our way of understanding astrology.',
        ],
      },
      {
        heading: 'This continues',
        paragraphs: [
          "Appstral is available on web and mobile. It's freemium, accessible, and sustained by the people who choose to become Stellar Members.",
          "We're still building, correcting, listening, and improving.",
        ],
      },
    ],
    contact: {
      title: 'Write to us',
      intro:
        "All of this grows thanks to you. We're a small team and we do what we can, so every message helps us a lot to improve. A bug, an idea, a complaint, a hello —whatever it is, tell us. We're the ones reading on the other side.",
      emailPlaceholder: 'Your email address',
      subjectPlaceholder: 'Subject',
      messagePlaceholder: 'Your message',
      sendButton: 'Send',
      sending: 'Sending',
      success:
        'Thanks for writing to us! We read it carefully. Appstral gets better thanks to messages like yours.',
      error: 'Something went wrong. Please try again in a moment.',
    },
    thanks: 'Thank you for being here.',
    storyLink: 'Our story',
    suggestionsLink: 'Complaints and suggestions',
    closeButton: 'Close',
  },
  forgotPasswordModal: {
    title: 'Reset Password',
    instruction: "Enter your email address and we'll send you a link to reset your password.",
    sendButton: 'Send Email',
    loading: 'Sending',
    closeButton: 'Close',
    successMessage: 'Reset email sent! Check your inbox (and spam folder).',
    userNotFound: 'There is no registered user with that email address.',
    invalidEmail: 'Invalid email format.',
    genericError: 'An error occurred while trying to send the email. Please try again.',
  },
  deleteAccountModal: {
    instructions: 'To permanently delete your account, you must enter your password.',
    passwordPlaceholder: 'Password',
    incorrectPasswordError: 'Incorrect password',
    cancelButton: 'Cancel',
    loadingButton: 'Deleting',
    submitButton: 'Delete Account',
  },
  consult_stella: 'Ask',
  chat: {
    newConversation: 'New conversation',
    confirmDelete: 'Are you sure you want to delete this conversation?',
    initialTitle: 'How can I assist you?',
    inputPlaceholder: 'Ask Stella',
    defaultApiError: "I'm sorry, there was an error with the response.",
    connectionError:
      "I'm sorry, I'm having trouble performing the necessary calculations right now. Please try again later.",
    quotaExhaustedBubble:
      "You've reached your Stella limit for today. You'll have more tomorrow, or get unlimited with Stellar.",
    quotaInputCta: "You've reached today's limit — become a Stellar member",
  },
  loadingPhrases: {
    interpreting: 'Interpreting the query...',
    positioningPlanets: 'Positioning planets...',
    estimatingDates: 'Estimating dates...',
    verifyingData: 'Verifying data...',
    revisingEphemeris: 'Revising ephemeris...',
    adjustingTelescope: 'Adjusting the telescope...',
    tracingAspects: 'Tracing aspects...',
  },
  irTienda: 'Go to Store',
  MobileBlock: 'Are you on a mobile device?',
  AppBlock: 'You can download Appstral on ',
  PlayStore: 'Play Store',
  calendar: {
    missingNatalData:
      'Please complete your natal information (date, time, city) to view your transits.',
    firstCalcWarning: 'The first annual calculation may take a few seconds...',
    noTransitsFound: 'No major transits found for the year {{year}}.',
    error: {
      missingData: 'Missing natal data (date, time, or coordinates) to calculate transits.',
      apiFailed: 'Error: {{error}}. Ensure the Flask backend is running at {{url}}.',
      connectionFailed: 'Failed to connect to the transits server. Check the URL.',
    },
  },
  months: {
    0: 'JAN',
    1: 'FEB',
    2: 'MAR',
    3: 'APR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AUG',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DEC',
  },
  tooltips: {
    fullTransitPhrase: "{{transitPlanet}}'s {{aspect}} to natal {{natalPlanet}}",
    shortTransitPhrase: '{{transitPlanet}} {{aspect}} natal {{natalPlanet}}',
  },
  dates: {
    start: 'Start',
    partil: 'Partile',
    end: 'End',
  },
};

export default en;
